<template>
  <div class="community-search-container">
    <div class="community-search-header flex-start">
      <span class="iconfont iconchevron-left" @click="pageBack"/>
      <form class="search-content" action="javascript:void 0">
        <input v-model="search" type="text" growing-track='true' @keyup.13="searchByKey('')" placeholder="输入关键词，如校招/内推/笔面经..." ref="inputText" @click="showHistory">
      </form>
    </div>
    <template v-if="historyState">
      <div class="history_container">
        <div class="search_history" v-show="historyData.length!=0">
          <div class="title">
            <h1>搜索历史</h1>
            <i class="trash iconfont icontrash-" @click="delStorage"></i>
          </div>
          <div class="data_container">
            <div class="data_item" v-for="(item,index) in historyData" :key="index" @click="searchHistory(item)">{{item}}</div>
          </div>
        </div>
        <div class="recommend_topic">
          <h1>推荐话题</h1>
          <div class="topic_list">
            <div class="topic_item" v-for="(item,index) in topicList" @click="searchTopic(item)">
              #&nbsp;&nbsp;&nbsp;{{item.name}}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="community-search-tab">
        <w-tab :tab-list="tabList" :current-tab="currentTab" @changeTab="changeTab"></w-tab>
      </div>
      <div class="scroll-container" v-show="currentTab === 0">
        <cube-scroll ref="scroll" :data="[currentTab]" :options="options" @pulling-up="onPullingUp">
          <div class="search-all">
            <div class="search-blog-content">
              <template v-for="(item, index) in searchListBlog">
                <blog-item :key="index" :data="item" v-if="index < 3" :search="true" :searchText="search"></blog-item>
              </template>
              <div class="blog-bottom" v-show="searchListBlog.length" @click="changeTab(2,2)">
                <span>查看全部攻略</span>
              </div>
            </div>
            <div class="search-article-content">
              <template v-for="(item, index) in searchListNews">
                <community-item :community-data="item" :key="index" :search="true" :searchText="search" class="all"></community-item>
              </template>
            </div>
          </div>
          <w-more-loading v-show="moreLoadingShow"></w-more-loading>
<!--          <w-no-more v-show="noMoreShow && !noResultShow"></w-no-more>-->
        </cube-scroll>
      </div>
      <div class="scroll-container" v-show="currentTab === 1">
        <cube-scroll :data="[currentTab]" :options="options" @pulling-up="onPullingUp">
          <div class="search-article">
            <template v-for="(item, index) in searchListNews">
              <community-item :community-data="item" :key="index" :search="true" :searchText="search" class="community"></community-item>
            </template>
          </div>
          <w-more-loading v-show="moreLoadingShow"></w-more-loading>
<!--          <w-no-more v-show="noMoreShow && !noResultShow"></w-no-more>-->
        </cube-scroll>
      </div>
      <div class="scroll-container" v-show="currentTab === 2">
        <cube-scroll :data="[currentTab]" :options="options" @pulling-up="onPullingUp">
          <div class="search-blog">
            <template v-for="(item, index) in searchListBlog">
              <blog-item :data="item" :key="index" :search="true" :searchText="search"></blog-item>
            </template>
          </div>
          <w-more-loading v-show="moreLoadingShow"></w-more-loading>
<!--          <w-no-more v-show="noMoreShow && !noResultShow"></w-no-more>-->
        </cube-scroll>
      </div>
      <w-no-results text="搜索结果空空如也~" v-show="noResultShow"></w-no-results>
    </template>
  </div>
</template>

<script>
	import WTab from '../../../components/global/w-tab'
	import blogItem from '../components/blog-item'
	import communityItem from '../components/community-item'
	import WMoreLoading from '../../../components/global/w-more-loading'
	import WNoMore from '../../../components/global/w-no-more'
  import WNoResults from '../../../components/global/w-no-result'
	import { mapActions, mapState } from 'vuex'
	import { loginMixin, envMixin } from '../../../assets/js/mixin/global'
  import {addClass, removeClass} from "../../../assets/js/dom";

	export default {
		name: 'community-search-list',
    mixins: [ loginMixin, envMixin ],
		data () {
			return {
				search: '',
				page: 1,
				tabList: [
					{ label: '全部' },
					{ label: '讨论' },
					{ label: '攻略' },
				],
				currentTab: 0,
				blogPage: 1, // 攻略页码
				// blogList: [], // 攻略数据
				// blogTotal: 0, // 攻略总数量
				newsPage: 1, //分页当前页数
				options: {
					pullUpLoad: true
				}, // scroll 事件配置
        historyState:true,
        historyData:[],
        topicList:[]
			}
		},
    activated() {
      this.historyState = true;
      this.search = ''
    },
    async mounted () {
			await this.loginByWx()
      let historyStr = this.$db.ls.get('searchHistory');
		  this.historyData = historyStr ? historyStr.split(',') : [];
		  this.getTopicData();
		},
		computed: {
			...mapState('community', [ 'searchListNews', 'searchListBlog', 'searchNewsTotal', 'searchBlogTotal' ]),
      // 更多的loading
			moreLoadingShow () {
				return (this.currentTab === 0 && this.searchListNews.length < this.searchNewsTotal) ||
					(this.currentTab === 1 && this.searchListNews.length < this.searchNewsTotal) ||
					(this.currentTab === 2 && this.searchListBlog.length < this.searchBlogTotal)
			},
      // 没有更多
			noMoreShow () {
				return (this.currentTab === 0 && this.searchListNews.length === this.searchNewsTotal) ||
					(this.currentTab === 1 && this.searchListNews.length === this.searchNewsTotal) ||
					(this.currentTab === 2 && this.searchListBlog.length === this.searchBlogTotal)
			},
      // 搜索的category
			categoryChoice () {
				if (this.currentTab === 0) {
					return ''
				} else if (this.currentTab === 1) {
					return 'news'
				} else {
					return 'page'
				}
			},
      // 搜索没有结果的空状态
      noResultShow () {
				return (!this.searchListNews.length && !this.searchListBlog.length && this.currentTab === 0) ||
          (!this.searchListNews.length && this.currentTab === 1) ||
          (!this.searchListBlog.length && this.currentTab === 2)
      }
		},
		watch: {
			currentTab (val) {
				this.$refs.scroll.scrollTo(0, 0)
        if(val==0){
          this.$nextTick(() => {
            let els = document.querySelectorAll('.all .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
              }
            }
          })
        }else if(val==1){
          this.$nextTick(() => {
            let els = document.querySelectorAll('.community .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.community .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.community .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.community .more-item')[i], 'more-item-show')
              }
            }
          })
        }
			}
		},
		components: {
			WTab,
			blogItem,
			communityItem,
			WMoreLoading,
			WNoMore,
      WNoResults
		},
		methods: {
			...mapActions('community', [ 'searchNews', 'searchBlog' ]),
      // 显示历史搜索
      showHistory(){
        this.historyState = true;
      },
			onPullingUp () {
				if (!this.noMoreShow) {
					if (this.currentTab === 0 || this.currentTab === 1) {
						this.newsPage += 1
						// this._searchByKey({ refresh: false })
            this.searchNews({
              payload:{
              	page:this.newsPage,
                size:10,
                keyword: this.search,
                category: 'news'
              },
              refresh:false
            })
					} else {
						this.blogPage += 1
						this.searchBlog({
              payload: {
              	page: this.blogPage,
                size: 10,
	              keyword: this.search,
	              category: 'page'
              },
              refresh: false
            })
					}
				}
			},
			// 页面返回事件
			pageBack () {
			  if (!this.historyState){
			    this.historyState = true
        }else {
          this.search = ''
          this.$router.back()
        }
			},
			// 切换tab
			changeTab (tab, index) {
				this.currentTab = index
			},
			// 搜索
			searchByKey (id) {
        this.historyState = false;
        this.currentTab = 0;
        if (this.search.length > 0) {
          if (this.historyData.length < 8){
            this.historyData.unshift(this.search);
          }else {
            this.historyData.pop();
            this.historyData.unshift(this.search);
          }
        }
        this.historyData = [...new Set(this.historyData)];
        this.$db.ls.set('searchHistory',this.historyData.join(','))
				this.newsPage = 1
        this.blogPage = 1
				this._searchByKey({ refresh: true, id })
			},
			// 通过关键字检索接口
			async _searchByKey ({ refresh,id }) {
				await this.searchNews({
					payload: {
						page: this.newsPage,
						keyword: this.search,
						size: 10,
						category: 'news',
            topic_id: id ? id : ''
					},
					refresh
				})
        await this.searchBlog({
          payload: {
            page: this.blogPage,
            keyword: this.search,
            size: 10,
            category: 'page',
            topic_id: id ? id : ''
          },
          refresh
        })
        this.$nextTick(() => {
          let els = document.querySelectorAll('.all .community-item-desc')
          for (let i = 0; i < els.length; i++) {
            removeClass(els[i], 'community-content-clip')
            removeClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
          }
          for (let i = 0; i < els.length; i++) {
            if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
              addClass(els[i], 'community-content-clip')
              addClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
            } else {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.all .more-item')[i], 'more-item-show')
            }
          }
        })
        // if (res.code === 1000) {
        // 	this.blogList = res.data.pages
        //   this.blogTotal = res.data.page_count
        //   console.log(this.blogList,"=====>list")
        //   // this.search = ''
        // }
			},
			// 清空本地存储
      delStorage(){
        this.historyData = [];
        this.$db.ls.set('searchHistory','')
      },
      // 获取话题
      async getTopicData(){
        let res = await this.$api.bbs.getTopics({page:1,size:100});
        if (res.code===1000){
          this.topicList = res.data.topics;
        }
      },
      searchHistory (item) {
			  this.search = item
        this.searchByKey();
      },
      // 点击话题搜索 跳转话题聚合页
      searchTopic(item){
        this.$db.ls.set('shareNeed', true)
        let { id, name, image } = item
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-group/news-group?url=${ process.env.VUE_APP_HOST }/community/topic/${ id }&title=${ name }&image=${ image }`
          })
        } else {
          this.$router.push(`/community/topic/${ id }`)
        }
      }
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .community-search-container {
    @include ipx-content-bottom(1px);
    .community-search-header {
      height: 44px;
      padding: 0 24px;
      .iconfont {
        font-weight: bold;
        font-size: 26px;
        color: $color-title;
        margin-right: 18px;
      }
      .search-content {
        flex: 1;
        input {
          width: 100%;
          height: 32px;
          border-radius: 16px;
          color: #9c9c9c;
          background-color: #f2f2f2;
          border: none !important;
          flex: 1;
          //color: $color-title;
        }
      }
    }
    //搜索历史
    .history_container{
      .search_history{
        .title{
          font-weight: bold;
          padding: 0 24px;
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          font-size: 14px;
          .trash{
            color: #9C9C9C;
          }
        }
        .data_container{
          max-height: 160px;
          display: flex;
          flex-wrap: wrap;
          padding: 0 24px;
          overflow: auto;
          //justify-content: space-between;
          .data_item{
            width: auto;
            height: 24px;
            color: #9c9c9c;
            background-color: #f9f9f9;
            line-height: 12px;
            padding: 6px 10px;
            margin-top: 16px;
            margin-right: 16px;
          }
        }
      }
      .recommend_topic{
        width: 100%;
        padding: 0 24px;
        margin-top: 16px;
        overflow: hidden;
        h1{
          margin-bottom: 16px;
        }
        .topic_list{
          height: auto;
          max-height: 365px;
          //max-height: 573px;
          overflow: auto;
          color: #404040;
          .topic_item{
            height: 50px;
            line-height: 50px;
            border-top: 1px solid #f9f9f9;
          }
        }
      }
    }
    .community-search-tab {
      padding-top: 6px;
      /deep/ .active::after {
        margin-top: 8px;
      }
    }
    .scroll-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 76px);
      @include ipx-content-bottom(1px);
    }
    .search-all {
      .search-blog-content {
        background-color: #F9F9F9;
        .blog-item-container {
          background-color: #F9F9F9;
        }
        .blog-bottom {
          border-top: 1px solid #f4f4f4;
          padding: 8px 16px;
          margin: 0 24px;
          color: #9c9c9c;
          font-size: $font-size-small;
        }
      }
      .search-article-content {
        background-color: #F9F9F9;
      }
    }
  }
</style>
